import { render, staticRenderFns } from "./UnionChart.vue?vue&type=template&id=23b57fb4&scoped=true"
import script from "./UnionChart.vue?vue&type=script&lang=js"
export * from "./UnionChart.vue?vue&type=script&lang=js"
import style0 from "./UnionChart.vue?vue&type=style&index=0&id=23b57fb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b57fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b57fb4')) {
      api.createRecord('23b57fb4', component.options)
    } else {
      api.reload('23b57fb4', component.options)
    }
    module.hot.accept("./UnionChart.vue?vue&type=template&id=23b57fb4&scoped=true", function () {
      api.rerender('23b57fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/union/components/UnionChart.vue"
export default component.exports